import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setObjectiveGroupComplete } from '../../../slices/ObjectivesSlice';
import useObjectiveGroupFractionComplete from './useObjectiveGroupFractionComplete';

const ObjectiveGroupLogicHandler = ({ objectiveGroup }) => {
  const dispatch = useDispatch();

  const fractionComplete = useObjectiveGroupFractionComplete(objectiveGroup);

  const [markedComplete, setMarkedComplete] = useState(false);

  // mark complete when done
  useEffect(() => {
    if (fractionComplete >= 1 && !markedComplete) {
      dispatch(setObjectiveGroupComplete(objectiveGroup.id));
      setMarkedComplete(true);
    }
  }, [dispatch, fractionComplete, markedComplete, objectiveGroup.id]);

  return <></>;
};

export default ObjectiveGroupLogicHandler;
